export default "__VITE_ASSET__BFgmGhKQ__"